import classNames from "classnames";
import { CashLedgerNode } from "../../build/types";
import { useInteractionStates } from "../../hooks/useInteractionStates";
import { CashLedgerComponentProps } from "../BuilderInterface";
import CashLedgerLayout from "../PrintLayouts/CashLedger";
import { getCompoundStyle, getStateStyleForBuilder, getStylesFromInteractiveStates } from "../helpers";
import "./style.scss";

const BuilderCashLedger: React.FC<CashLedgerComponentProps> = ({
    node,
    cashLedgerData,
    builderProps,
    formatCurrency
}: CashLedgerComponentProps) => {
    const cashLedgerNode = node as CashLedgerNode;
    const { attr, id, stateManager } = cashLedgerNode;
    const { setElement, states } = useInteractionStates<HTMLDivElement>();

    const cashLedgerClassName = classNames("cash-ledger-builder-wrapper", {
        [`${attr?.className}`]: !!attr?.className
    });

    if (builderProps) {
        const { nodeState, selectedMenu, selectCallback, outlineCallback, onDragStart, onDragEnd } = builderProps;

        return (
            <div
                {...attr}
                className={cashLedgerClassName}
                style={getCompoundStyle({
                    node,
                    stateStyle: getStateStyleForBuilder(stateManager, nodeState, "attr_style")
                })}
                onClick={e => (selectCallback ? selectCallback(e, id) : {})}
                onMouseMove={e => (outlineCallback ? outlineCallback(e, id) : {})}
                id={id}
                onDragStart={e => onDragStart?.(e, id)}
                draggable={"true"}
                onDragEnd={onDragEnd}
            >
                <div id="print">
                    <CashLedgerLayout
                        node={cashLedgerNode}
                        cashLedgerData={cashLedgerData}
                        formatCurrency={formatCurrency || ((amount: number) => amount.toFixed(2))}
                    />
                    {selectedMenu}
                </div>
            </div>
        );
    } else {
        const { style, ...rest } = attr || {};

        const cashLedgerStyle = getStylesFromInteractiveStates({
            states,
            defaultStyle: getCompoundStyle({ node }),
            stateManager,
            paths: ["attr_style"]
        });

        return (
            <div ref={setElement} style={cashLedgerStyle} {...rest} className={cashLedgerClassName}>
                <div id="print">
                    <CashLedgerLayout
                        node={cashLedgerNode}
                        cashLedgerData={cashLedgerData}
                        formatCurrency={formatCurrency || ((amount: number) => amount.toFixed(2))}
                    />
                </div>
            </div>
        );
    }
};

export default BuilderCashLedger;
